function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.192 23.122 h -14.44 c -3.133 0 -5.682 -2.548 -5.682 -5.681 V 3 h 6 v 14.122 h 14.122 V 23.122 z",
    style: {
      stroke: "none",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "grey",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 73.249 90 H 16.75 c -3.277 0 -5.943 -2.666 -5.943 -5.942 V 5.943 C 10.808 2.666 13.474 0 16.75 0 h 41.101 c 1.588 0 3.08 0.618 4.202 1.741 l 15.397 15.398 c 1.123 1.123 1.741 2.615 1.741 4.202 v 62.717 C 79.192 87.334 76.526 90 73.249 90 z M 57.812 5.983 L 16.75 6 l 0.057 78.058 L 73.249 84 l -0.057 -62.635 L 57.812 5.983 z",
    style: {
      stroke: "none",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "grey",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 61.667 L 45 61.667 c -2.239 0 -4.054 -1.815 -4.054 -4.054 V 31.705 c 0 -2.239 1.815 -4.054 4.054 -4.054 h 0 c 2.239 0 4.054 1.815 4.054 4.054 v 25.908 C 49.054 59.852 47.239 61.667 45 61.667 z",
    style: {
      stroke: "none",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "grey",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 73.985 L 45 73.985 c -2.239 0 -4.054 -1.815 -4.054 -4.054 v 0 c 0 -2.239 1.815 -4.054 4.054 -4.054 h 0 c 2.239 0 4.054 1.815 4.054 4.054 v 0 C 49.054 72.17 47.239 73.985 45 73.985 z",
    style: {
      stroke: "none",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "grey",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.929b0a9ce891ca298734865ca6fd24ac.svg";
export { ForwardRef as ReactComponent };